import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import logo from '../../assets/images/reexoasset.png'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { sidebar } from '../../redux/slices/user-login/Sidebar'
import { SessionManager } from '../../utils'
import Menu from 'antd/es/menu'
import ConfigProvider from 'antd/es/config-provider'
import { Drawer } from 'antd'

export const SidebarImport = {
    ConfigProvider,
    Menu,
    Drawer,
    PerfectScrollbar,
    logo,
    useDispatch,
    useSelector,
    Link,
    useNavigate,
    useLocation,
    sidebar,
    SessionManager
}